import styled from 'styled-components';

import colors from 'themes/Main';

const { white, gray06 } = colors;

export const Container = styled.div`
  ${({ blocks }) => `

      width: 100%;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      align-items: center;
      padding: 16px 32px;
      min-height: 84px;
      background-color: ${white};

      &:not(:last-child) {
        border-bottom: 1px solid ${gray06};
      }
      > div {
        width: ${
          blocks > 1
            ? `calc((100% - 214px) / ${blocks})`
            : 'calc((100% - 214px) / 1)'
        };
        padding: ${blocks > 1 ? '0' : '0 0 0 32px'};
        min-width: 60px;
        text-align: center;
        justify-content: center;
        height: fill-available;
      }
      > div:first-of-type {
        width: 190px;
        padding: 0;
        min-height: fill-available;
        margin-right: 24px;
        text-align: left;
        justify-content: flex-start;
      }

  `}
`;
